import React from 'react'

import { Button } from 'react-bootstrap'
import { LuTable2 } from 'react-icons/lu'
import { t } from 'i18next'
import { ImSpinner9 } from 'react-icons/im'

export default function ExportExcel({
  fnExportExcel,
  disabled,
  loading = false
}) {
  const isDisabled = disabled || loading
  return (
    <Button
      disabled={isDisabled}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: 'var(--color-primary-content-default)',
        backgroundColor: 'var(--comp-btn-color-background-secondary-normal)',
        border: '1px solid var(--color-primary-border-default)',
        fontSize: 12,
        fontWeight: 500,
        opacity: isDisabled ? 0.5 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer'
      }}
      onClick={() => fnExportExcel()}
    >
      <>
        {loading === true ? (
          <ImSpinner9
            size={16}
            style={{ animation: '0.75s linear infinite spinner-border' }}
          />
        ) : (
          <LuTable2 size={16} />
        )}
        <div>{t('hrms_attendance_export_bt')}</div>
      </>
    </Button>
  )
}
